module.exports = __webpack_public_path__ + "static/media/229.219b4965.wav";